<template>
<el-card class="card">
    <template v-slot:header>
    <div class="header-content">
        <div class="header-left">
        <span style="font-weight: bold;">
            <i class="el-icon-s-data" style="font-weight: bold; font-size: larger; margin-right: 5px;"></i>Single Gene Expression
        </span>
        </div>
        <div class="header-right">
        <el-autocomplete
            v-model="tf"
            placeholder="Enter Gene"
            :trigger-on-focus="false"
            clearable
            @clear="clearTF"
            :fetch-suggestions="querySearch">
            <template v-slot:prepend>
                <span class="prepended-text">Gene name:</span>
            </template>
        </el-autocomplete>
        </div>
    </div>
    </template>
    <div>
    <div ref="areaChart" style="width: 100%; height: 400px;"></div>
    </div>
</el-card>
</template>

<script>
export default {
data() {
    return {
    url: "http://183.175.59.4/devenhancer/",
    endpoint: "upexpr",
    chartData: [],
    xAxisData: [],
    yAxisData: [],
    barColors: [],
    lineColors: [],
    tf: 'Gata4', // 默认基因
    symbolOptions: [], // 符号提示词选项
    };
},
props: {
    species: {
    type: String,
    required: true,
    },
    tissue: {
    type: [String, Array],
    required: true,
    },
},
created() {
    this.fetchData();
},
watch: {
    tf(newVal) {
    // 监听转录因子的变化，重新获取数据
    this.fetchData(newVal);
    },
},
methods: {
    querySearch(queryString, cb) {
    if (!queryString) {
        cb([]);
        return;
    }
    // 发送异步请求到后端，获取匹配的基因选项
    this.$axios.get(`${this.url}${this.endpoint}/`, { params: { query: queryString } })
        .then(response => {
        // 使用 Set 来保存不重复的基因
        this.uniqueTfOptions = new Set(response.data.map(item => item.SYMBOL));

        // 将 Set 转为数组，以便提供给 el-autocomplete
        const tfbsArray = Array.from(this.uniqueTfOptions).map(SYMBOL => ({ value: SYMBOL, label: SYMBOL }));

        // 模糊搜索，筛选出包含用户输入的基因作为提示
        const filteredTfbs = tfbsArray.filter(item => item.label.toLowerCase().includes(queryString.toLowerCase()));
        
        cb(filteredTfbs);
        })
        .catch(error => {
        console.error('Error fetching gene options:', error);
        cb([]);
        });
    },
    fetchData(tf = this.tf) {
    const params = {
        Species: this.species,
        Tissue: this.tissue,
        SYMBOL: tf,
    };
    this.$axios.get(`${this.url}${this.endpoint}/`, { params })
        .then(response => {
        // 重置数据数组
        this.chartData = response.data;
        this.xAxisData = [];
        this.yAxisData = [];
        this.barColors = [];
        this.lineColors = [];
        // 提取并渲染新数据
        this.extractChartData();
        this.generateRandomColors();
        this.renderChart();
        })
        .catch(error => {
        console.error('获取数据时出错:', error);
        });
    },
    extractChartData() {
    const backendTissues = Array.from(new Set(this.chartData.map(item => item.Tissue)))
        .sort((a, b) => this.tissue.indexOf(a) - this.tissue.indexOf(b));

    for (const tissue of this.tissue) {
        if (!backendTissues.includes(tissue)) {
        this.xAxisData.push(tissue);
        this.yAxisData.push(0);
        }
    }
    this.xAxisData = this.xAxisData.concat(backendTissues);
    this.xAxisData.sort((a, b) => this.tissue.indexOf(a) - this.tissue.indexOf(b));
    this.yAxisData = this.xAxisData.map(tissue => {
        const item = this.chartData.find(item => item.Tissue === tissue);
        const upexValue = item ? item.Upex : 0;
        return upexValue;
    });
    },
    generateRandomColors() {
    const randomColors = Array.from({ length: this.yAxisData.length }, () =>
        `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)`
    );
    this.barColors = randomColors;
    const lineColors = Array.from({ length: this.yAxisData.length }, () =>
        `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)`
    );
    this.lineColors = lineColors;
    },
    renderChart() {
    const chart = this.$echarts.init(this.$refs.areaChart);
    const option = {
        title: {
        text: `${this.tf} expression`,
        textStyle: {
            fontSize: 14,
            fontWeight: 'bold',
        },
        left: 'center',
        top: 'top',
        },
        tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            crossStyle: {
            color: '#999'
            },
        }
        },
        xAxis: {
        type: 'category',
        name:'Tissue',
        nameTextStyle: {
            fontSize: 20, // 设置字体大小为20px
            color: 'black', // 设置字体颜色为黑色
        },
        data: this.xAxisData,
        axisLabel: {
            show: true,
            interval: 0,
            rotate: 0,
            textStyle: {
                fontSize: 20, // 设置字体大小为14px
                color: 'black', // 设置字体颜色为黑色
            }
        },
        },
        yAxis: {
        type: 'value',
        name: 'TPM',
        nameTextStyle: {
            fontSize: 20, // 设置字体大小为20px
            color: 'black', // 设置字体颜色为黑色
        },
        axisLabel: {
            show: true,
            interval: 0,
            rotate: 0,
            textStyle: {
                fontSize: 20, // 设置字体大小为14px
                color: 'black', // 设置字体颜色为黑色
            }
        },
        },
        series: [
        {
            type: 'bar',
            data: this.yAxisData,
            itemStyle: {
            color: params => this.barColors[params.dataIndex],
            },
            barWidth: 30,
        },
        {
            type: 'line',
            data: this.yAxisData,
            smooth: true,
            lineStyle: {
            color: params => this.lineColors[params.dataIndex],
            },
        },
        ],
    };

    chart.setOption(option);
    },
    clearTF() {
    this.tf = 'GATA6'; // 清空输入框时恢复默认转录因子为 GATA6
    },
},
};
</script>

<style scoped>
.card {
    margin-top: 10px;
}
.header-content {
    display: flex;
    justify-content: space-between;
}
.header-left {
    flex: 1;
}
.header-right {
    flex: 1;
    text-align: right;
}
.prepended-text {
    font-weight: bold;
    color: grey;
}
</style>


// WEBPACK FOOTER //
// src/components/comparison/Singlegene.vue